import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { BehaviorSubject } from 'rxjs';
import { Product, ProductImageContainer } from '@b2b/features/product/core/utilities/product.model';
import { MediaComponent } from '@shared/components/media/media.component';

@Component({
  selector: 'product-thumb-images',
  imports: [CommonModule, CarouselModule, MediaComponent],
  templateUrl: './product-thumb-images.component.html',
  styleUrl: './product-thumb-images.component.scss',
})
export class ProductThumbImagesComponent implements OnInit, OnChanges {
  @Input() product!: Product;
  @Input() currentImage!: ProductImageContainer;
  @Output() setContainer = new EventEmitter<ProductImageContainer>();

  containerImages$ = new BehaviorSubject<ProductImageContainer[]>([]);

  ngOnInit(): void {
    this.updateImages();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['product'] && !changes['product'].firstChange) {
      this.updateImages();
    }
  }

  private updateImages(): void {
    const images = this.product?.medias?.images || [];
    this.containerImages$.next(images);
  }

  setImage(productImage: ProductImageContainer): void {
    this.setContainer.next(productImage);
  }
}
